<div fxLayout="row" fxLayoutAlign="center center" fxFlex>
    <div class="panel" style="width:500px">
        <div class="panel-header padding">
            Access Denied
        </div>

        <div style="padding:20px" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="30px">
            <mat-icon style="font-size:40px;color:#F44336;">error_outline</mat-icon>
            <div style="color:#F44336"> You are not authrorize to access this page.
                <br/> Please click on the back button to try again</div>
        </div>
    </div>
</div>